import { render } from "./cj.vue?vue&type=template&id=fb66c3b0&scoped=true"
import script from "./cj.vue?vue&type=script&lang=js"
export * from "./cj.vue?vue&type=script&lang=js"

import "./cj.vue?vue&type=style&index=0&id=fb66c3b0&lang=less&scoped=true"

import exportComponent from "/Users/shixiaolong/Desktop/code/海玛_EN/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb66c3b0"]])

export default __exports__